import {
  useGetCustomTemplatesQuery,
  useGetDefaultConfigurationTemplateFieldsQuery,
} from 'src/services';

// Fetches the two template-level data sources the rest of the page depends
// on: the default form-field template and the account's custom templates.
export const useConfigurationTemplateData = () => {
  const { data: defaultTemplateFields, isLoading: isLoadingDefaultTemplateFields } =
    useGetDefaultConfigurationTemplateFieldsQuery(undefined as any) as any;
  const { data: customTemplatesData, isLoading: isLoadingCustomTemplates } =
    useGetCustomTemplatesQuery(undefined as any) as any;

  return {
    defaultTemplateFields,
    isLoadingDefaultTemplateFields,
    customTemplatesData,
    isLoadingCustomTemplates,
  };
};
